import {UIGameManager} from '../UIGameManager'
import {KeyBindController, ShortcutLocation} from '../../KeyBindController'
import {playDiceSound} from './UIGameDiceSounds'
import {UIGameDiceController} from './UIGameDiceController'
import {MechanicEventDiceState, TurnState} from '@colonist/game-states'

export abstract class UIGameBaseDiceController extends UIGameDiceController {
    protected readonly isRedDiceActive: boolean

    constructor(uiGameManager: UIGameManager, eventDiceState: MechanicEventDiceState | undefined) {
        super(uiGameManager)

        this.isRedDiceActive = eventDiceState !== undefined
        const onSpaceButtonCallback = () => {
            if(this.uiGameManager.gameController.currentState.turnState != TurnState.Dice) return
            this.clickedDice(this.playerDiceView)
        }
        KeyBindController.bindKey('Space', () => onSpaceButtonCallback(), () => this.isListeningForKeyPress(), ShortcutLocation.InGame)
        this.initializePlayerDiceView()
        this.initializeOpponentDiceViews()
        this.initializeCurrentTurnPlayer()
        this.startPlayerDiceAnimation()
        this.updateDiceImage()
        this.updateDiceView()
    }

    private isListeningForKeyPress(): boolean {
        if(this.uiGameManager.pauseController.isPaused()) return false
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(!this.currentActionStateIsEmpty()) return false
        return true
    }

    protected diceStateUpdated() {
        super.diceStateUpdated()
        if(this.uiGameManager.gameController.isReplay) return
        if(!this.uiGameManager.gameController.diceState.diceThrown) return

        const totalDiceNumber = this.uiGameManager.gameController.diceState.dice1 + this.uiGameManager.gameController.diceState.dice2
        playDiceSound(totalDiceNumber, this.uiGameManager.gameController.isMyTurn)
    }
}
